import { render, staticRenderFns } from "./fireResistantStructSpecInfoDetail.vue?vue&type=template&id=41471340"
import script from "./fireResistantStructSpecInfoDetail.vue?vue&type=script&lang=js"
export * from "./fireResistantStructSpecInfoDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41471340')) {
      api.createRecord('41471340', component.options)
    } else {
      api.reload('41471340', component.options)
    }
    module.hot.accept("./fireResistantStructSpecInfoDetail.vue?vue&type=template&id=41471340", function () {
      api.rerender('41471340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/lbe/frss/fireResistantStructSpecInfoDetail.vue"
export default component.exports